import React, { useState, useEffect } from "react";
import { Form, Button, Modal, Row, Col } from "antd";
import { vsmMunicipalityName, vsmNotify } from "../../../../config/messages";
import useStore from "../../../../store";
import { observer } from "mobx-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import InputComponent from "../../../../component/InputComponent";
import debounce from "lodash/debounce";

const EditComponent = observer((props) => {
	const [form] = Form.useForm();
	const {
		ManageMunicipalityNameStore,
		ManageMunicipalityNameStore: {
			EditData,
            editValues
		},
	} = useStore();
	const [saving, setSaving] = useState();
	const [disabled, setDisabled] = useState(true);
	// Handle submit and call function to save new record
	const handleSubmit = (data) => {
        setSaving(true);
        data.id = editValues.id;
		EditData(data)
			.then((data) => {
				close();
				vsmNotify.success({
					message: data.STATUS.NOTIFICATION[0],
				});
			})
			.catch((e) => {
				if (e.errors) {
					form.setFields(e.errors);
				}
			})
			.finally(() => setSaving(false));
	};

    // set the form values to edit
	useEffect(() => {
		if (editValues && props.visible) {
			form.setFieldsValue({
				name: editValues.name,
				is_municipal_apply: editValues.is_municipal_apply,
				is_discounted: editValues.is_discounted,
			});
		}
	}, [ManageMunicipalityNameStore, editValues, form, props]);

	// check for valid form values then accordingly make save button disable / enable
	const handleChange = debounce(() => {
		form
			.validateFields()
			.then((d) => {
				setDisabled(false);
			})
			.catch((d) => {
				setDisabled(true);
			});
	}, 500);

	// reset form and close add form
	const close = () => {
		props.close();
		form.resetFields();
		setDisabled(true);
	};

	return (
		<Modal
			className="editModal"
			centered
			title="Edit Municipality Name"
			width={534}
			visible={props.visible}
			closeIcon={<FontAwesomeIcon icon={faTimes} />}
			onCancel={close}
			cancelButtonProps={{ style: { display: "none" } }}
			okButtonProps={{ style: { display: "none" } }}
			footer={[
				<Button
					key="2"
					htmlType="button"
					className="cancelBtn mr-35"
					onClick={close}
				>
					Cancel
				</Button>,
				<Button
					key="1"
					disabled={disabled}
					form="editMunicipalityNameForm"
					loading={saving}
					htmlType="submit"
					type="primary"
				>
					Save
				</Button>,
			]}
		>
			<Form
				form={form}
				id="editMunicipalityNameForm"
				onFinish={handleSubmit}
				labelCol={{ span: 24 }}
				onChange={handleChange}
			>
				<Row gutter={30}>
					<Col xs={{ span: 24 }} sm={{ span: 24 }}>
						<InputComponent
							type="text"
							required
							label="Municipality Name"
							placeholder="Municipality Name"
							name="name"
							rules={vsmMunicipalityName.validation.name}
						/>
					</Col>
					<Col xs={{ span: 12 }} sm={{ span: 12 }}>
						<InputComponent
							type="radio_button"
							label="Is Apply Muni. Tax ?"
							name="is_municipal_apply"
							options={{
								values: [
									{ id: 0, name: "No" },
									{ id: 1, name: "Yes" },
								],
								value_key: "id",
								text_key: "name",
							}}
						/>
					</Col>
					<Col xs={{ span: 24 }} sm={{ span: 24 }}>
						<InputComponent
							type="radio_button"
							label="Choose Discount On"
							name="is_discounted"
							options={{
								values: [
									{ id: 0, name: "Basic of Vehicle" },
									{ id: 1, name: "Chassis compare" },
									{ id: 2, name: "After ex-showroom" },
									{ id: 3, name: "Ex-showroom" }
								],
								value_key: "id",
								text_key: "name",
							}}
						/>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
});

export default EditComponent;
